import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledFilterHeader = styled(FlexBox)<{ opened: boolean; changeHeight?: boolean; isActive: boolean }>`
    cursor: pointer;
    padding: 14px 12px;
    user-select: none;
    border-top: ${({ opened }) =>
        opened ? '1px solid rgba(255, 255, 255, 0.15)' : '1px solid rgba(255, 255, 255, 0.06)'};

    ${media.sm`
       padding: 14px 16px;
    `};
`;

export const StyledFilterContent = styled.div<{ opened: boolean }>`
    max-height: ${({ opened }) => (opened ? 'auto' : '0')};
    overflow: hidden;
    padding: ${({ opened }) => (opened ? '8px 12px 20px 8px' : '0')};
    color: white;
`;

export const StyledAuthTrigger = styled(Typography)`
    cursor: pointer;
    color: ${({ theme }) => theme.colors.cyan500};
    font: inherit;

    :hover {
        color: ${({ theme }) => theme.colors.cyan700};
    }
`;

export const StyledFilterBy = styled(Typography)`
    padding: 14px 0;
    margin-bottom: 8px;
`;